import { ITERABLE_API_HOST } from 'constants/urls';
import camelCase from 'lodash/camelCase';
import { CampaignType, Conversion, MessageMedium } from 'modules/domains/campaign';
import { Destination, DestinationDescription } from './constants';
import { WhatsApp } from 'constants/messageMediums';

/**
 * Returns a list of events from conversions
 * @param conversions
 */
export const getConversionEvents = (conversions: Conversion[]) => {
  const isSet = conversions?.filter?.((conversion) => conversion?.events?.length).length;
  const events: string[] = [];

  if (isSet) {
    conversions.forEach((conversion) =>
      conversion.events.forEach((e) => {
        events.push(e.name);
      }),
    );
  }

  return events;
};

/**
 * Returns trigger api url for a given medium
 * @param medium
 */
export const getTriggerApiUrlForMedium = (medium: MessageMedium) => {
  const host = ITERABLE_API_HOST;
  const baseUrl = host.includes('localhost') ? `http://${host}` : `https://${host}`;
  const mediumPath = medium === WhatsApp ? medium.toLowerCase() : camelCase(medium);

  return `${baseUrl}/api/${mediumPath}/target`;
};

/**
 * Returns whether a campaign is a blast campaign
 * @param campaignType
 */
export const getIsBlastCampaign = (campaignType: CampaignType) =>
  campaignType === CampaignType.Blast;

/**
 * Makes mobileAppIds human-readable
 * @param mobileAppIds
 */
export const humanizeMobileAppIds = (mobileAppIds: number[]) => {
  // Copy-pasted from reviewCampaign.controller.js
  // Infer which targeting option was chosen based on mobileAppIds
  if (mobileAppIds.length === 0) {
    return DestinationDescription.ALL_MOBILE_APPS;
  } else if (mobileAppIds[0] === Destination.ALL_WEBSITES) {
    return DestinationDescription.ALL_WEBSITES;
  } else if (mobileAppIds[0] === Destination.EVERYTHING) {
    return DestinationDescription.EVERYTHING;
  } else if (mobileAppIds[0] === Destination.OTT) {
    return DestinationDescription.OTT;
  } else {
    return DestinationDescription.CUSTOM;
  }
};
